import React from 'react';
import { useContext } from 'react';
import SimpleContext from './../context/SimpleContext';
import config from './../../services/config.json';
import NumberFormat from 'react-number-format';
import Date from './../Date/Date';
import './Banners.css';

const MyList = () => {

    const context = useContext(SimpleContext)
    
    let arrayOfMyList  = [];
    
    for (let i = 0; i < context.MyList.length; i++) {
        for (let j = 0; j < context.products.length; j++) {
            if (context.MyList[i] === context.products[j].slug) {
                arrayOfMyList.push({...context.products[j]});
            }
        }
    }


    return ( 
        <>
            <div className="AllMyListPage">
                <div className="otherPagesHeader">
                    <div className="barbuttonn">
                        <img src="images/Api.jpg" className="apiLogoHeaders" alt=""/>
                    </div>
                    <div className="headersNames">
                        <p style={{margin:"0"}}>مشخصات کاربر</p>
                    </div>
                    <div className="pt-2">
                        <p style={{marginTop:"3%", fontSize:"13px"}}>
                            <Date/>
                        </p>
                    </div>
                </div>
            <div className="Holder">
                {
                    arrayOfMyList.map((pr, i) => 
                        <div className="MiniPro" key={i}>
                            <div className="MiniImgPlace">
                                <img style={{width:"100%", borderRadius:"12px"}} src={`${config.AndroidProductsPictures}/${pr.slug}.jpg`} alt=""/>
                            </div>
                            <div className="MiniTextPlace">
                                <p>
                                    {pr.name}
                                </p><br/>
                                <p>
                                    قیمت: 
                                    <NumberFormat value={pr.price * pr.number_in_unit} displayType={'text'} thousandSeparator={true} /> ريال<br/><br/>
                                </p>
                            </div>
                        </div>    
                    )
                }
            </div>
        </div>
        </>
    );
}
 
export default MyList;